/* gb_meta_ids.js - CANDIDATE (not deployed). Carries the visitor's REAL Meta browser identifiers into the Shopify cart so they land on the order (note_attributes) and the server feed can send them.
   Rules: (1) only when the visitor has consented (Shopify Customer Privacy API: marketing allowed, or userCanBeTracked when marketingAllowed is unavailable);
          (2) _fbp is copied only from the real first-party cookie; _fbc only from the real cookie, or built from a REAL fbclid in the landing URL in Meta's documented format fb.1.<ms>.<fbclid>; never invented;
          (3) values that do not match Meta's format are dropped, never repaired; (4) one cart write per change (sessionStorage guard); (5) every step in try/catch so the storefront can never break.
   Cart attributes are written with names _fbp / _fbc (underscore = hidden from the customer at checkout, kept on the order). Express buy-now buttons that skip the cart will not carry them (measured after launch, never assumed). */
(function (w, d) {
  var FBP_RE = /^fb\.[0-2]\.\d{13}\.\d{5,}$/;
  var FBC_RE = /^fb\.[0-2]\.\d{13}\.[A-Za-z0-9_\-]{10,}$/;
  var KEY = 'gbMetaIdsSent';
  function consentOK() {
    try {
      var cp = w.Shopify && w.Shopify.customerPrivacy;
      if (!cp) return false;
      if (typeof cp.marketingAllowed === 'function') return !!cp.marketingAllowed();
      if (typeof cp.userCanBeTracked === 'function') return !!cp.userCanBeTracked();
      return false;
    } catch (e) { return false; }
  }
  function cookie(name) {
    try {
      var m = (d.cookie || '').split('; ');
      for (var i = 0; i < m.length; i++) { var p = m[i].split('='); if (p[0] === name) return decodeURIComponent(p.slice(1).join('=')); }
    } catch (e) {}
    return '';
  }
  function fbclidFromUrl() {
    try { var q = new URLSearchParams(w.location.search); var v = q.get('fbclid'); return v && /^[A-Za-z0-9_\-]{10,}$/.test(v) ? v : ''; } catch (e) { return ''; }
  }
  function collect() {
    var out = {};
    var fbp = cookie('_fbp'); if (FBP_RE.test(fbp)) out._fbp = fbp;
    var fbc = cookie('_fbc');
    if (!FBC_RE.test(fbc)) {
      fbc = '';
      var id = fbclidFromUrl();
      if (id) fbc = 'fb.1.' + Date.now() + '.' + id;   /* real click id only; Meta format */
    }
    if (fbc && FBC_RE.test(fbc)) out._fbc = fbc;
    return out;
  }
  function run() {
    try {
      if (!consentOK()) return;
      var ids = collect();
      if (!Object.keys(ids).length) return;
      var sig = JSON.stringify(ids), prev = '';
      try { prev = w.sessionStorage.getItem(KEY) || ''; } catch (e) {}
      if (prev === sig) return;
      var p = w.fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: ids }), credentials: 'same-origin' });
      if (p && p.then) p.then(function (r) { if (r && r.ok) { try { w.sessionStorage.setItem(KEY, sig); } catch (e) {} } }).catch(function () {});
    } catch (e) {}
  }
  /* run after load, after consent changes, and shortly after add-to-cart so a fresh cart gets the attributes before checkout */
  if (d.readyState === 'complete') run(); else w.addEventListener('load', function () { setTimeout(run, 1500); });
  d.addEventListener('visitorConsentCollected', function () { setTimeout(run, 500); });
  d.addEventListener('trackingConsentChanged', function () { setTimeout(run, 500); });
  d.addEventListener('submit', function (e) { try { if (e.target && e.target.action && e.target.action.indexOf('/cart/add') !== -1) setTimeout(run, 1500); } catch (x) {} }, true);
  w.__gbMetaIds = { collect: collect, consentOK: consentOK, run: run };   /* test hook; read-only helpers */
})(window, document);
